import { ElementRef } from '@angular/core';
import { isTabletPortrait } from 'Angular/utils/media';
import * as i0 from "@angular/core";
import * as i1 from "../general-chart/general-chart.component";
export class GeneralChartResponsiveComponent {
    constructor(eltRef) {
        this.eltRef = eltRef;
        this.chartOptions = JSON.parse(eltRef.nativeElement.getAttribute('chartOptions'));
        this.configurableOptions = JSON.parse(eltRef.nativeElement.getAttribute('configurableOptions'));
        this.chartUrlMobile = eltRef.nativeElement.getAttribute('chartUrlMobile');
        this.chartUrlDesktop = eltRef.nativeElement.getAttribute('chartUrlDesktop');
        window.onresize = this.determineChartDataUrl;
    }
    ngOnInit() {
        this.determineChartDataUrl();
    }
    determineChartDataUrl() {
        // If window is tablet size, set url to mobile url
        if (isTabletPortrait()) {
            this.chartDataUrl = this.chartUrlMobile;
        }
        else {
            this.chartDataUrl = this.chartUrlDesktop;
        }
    }
}
GeneralChartResponsiveComponent.ɵfac = function GeneralChartResponsiveComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GeneralChartResponsiveComponent)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
GeneralChartResponsiveComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GeneralChartResponsiveComponent, selectors: [["ycn-general-chart-responsive"]], standalone: false, decls: 1, vars: 3, consts: [[3, "chartDataUrl", "chartOptions", "configurableOptions"]], template: function GeneralChartResponsiveComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "ycn-general-chart", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("chartDataUrl", ctx.chartDataUrl)("chartOptions", ctx.chartOptions)("configurableOptions", ctx.configurableOptions);
    } }, dependencies: [i1.GeneralChartComponent], encapsulation: 2 });
